<div [ngSwitch]="hasBulkSelection">
  <ng-template [ngSwitchCase]="true">
    <ian-action-toolbar
      *ngIf="isLoading === false"
      [totalItemsSelected]="totalItemsSelected"
      [actions]="actionToolbarActions"
      (actionExecuted)="executeAction($event)"
      (clearSelected)="clearSelected()"
    ></ian-action-toolbar>
  </ng-template>
  <ng-template [ngSwitchCase]="false">
    <ian-default-toolbar
      [actions]="toolbarActionButtons"
      (actionExecuted)="executeAction($event)"
      [minLength]="1"
      [showTextSearchInput]="showTextSearchInput"
      [disableTextSearchInput]="disableTextSearchInput"
      (filterSearch)="onSearch($event)"
    ></ian-default-toolbar>
  </ng-template>
</div>
